import { Row, Col, ClassifyStructure, Form, message, Input, jsonToQueryString, Button, MainModal, Tag, Typography, Tabs, Select, Switch } from '../ui/ot';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createContext } from 'react';
import { useDepartmentDepth } from './controllers/department_depth_controller'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'antd/es/form/Form';

const LanguageContext = createContext(null)

const DepthDataManagement = ({
    keyPrefix = "organization_structure.depth",
    mode = 'departmentRole',
    permission_modal_mode = 'group',
    showMode = "page",
    backEditPath = "department",
    propsShowDepthTabs = false
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [searchParams] = useSearchParams()
    const queryString = searchParams.toString();
    const departmentIdExternal = searchParams?.get('department_id')
    const departmentDepthIdExternal = searchParams?.get('department_depth_id')
    const fromDepartmentId = searchParams?.get('from_department_id')
    const navigate = useNavigate()
    const [departmentData, setDepartmentData] = useState([]);
    const [departmentDepthDatas, setDepartmentDepthDatas] = useState([]);
    const [userData, setUserData] = useState([]);
    const [departmentProcessData, setDepartmentProcessData] = useState([]);
    const [roleProcessData, setRoleProcessData] = useState([]);
    const [departmentId, setDepartmentId] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [departmentName, setDepartmentName] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({
        edit: true,
        prefix: "department",
        languageKey: "department_language_data",
        node: [],
        data: { name: "" }
    });
    const current_department_id = useRef()
    const selectRef = useRef()
    const [forceReload, setForceReload] = useState(0)
    const [loading, setLoading] = useState(true)
    const tabDepartmentId = useRef(fromDepartmentId != null ? parseInt(fromDepartmentId) : undefined)
    const [showDepthTabs, setShowDepthTabs] = useState(propsShowDepthTabs)

    const [form] = Form.useForm();
    /* PermissionModal */

    const addModal = (prefix, languageKey, node) => {

        setModalData((prev) => {
            return {
                edit: false,
                prefix: prefix,
                languageKey: languageKey,
                node: node,
                data: { name: "" }
            }
        })
        setModalShow(true)
    }

    const editModal = (prefix, languageKey, node) => {
        let data = {
            "name": node[`${languageKey}`]?.[0]?.language_culture_value !== undefined
                ? node[`${languageKey}`]?.[0]?.language_culture_value
                : node.name

        }
        setModalData({
            edit: true,
            prefix: prefix,
            languageKey: languageKey,
            node: node,
            data: data
        })
        setModalShow(true)
    }

    const deleteDepartment = (node, classify_structure_type_id) => {
        let url = `/organization_structure/api/department`;
        let data = [{
            "department_id": node.department_id,
            "classify_structure_id": 9,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("department", url, data, classify_structure_type_id)

    }

    //刪除訊息、找刪除節點
    const deleteNode = (type, url, data, classify_structure_type_id) => {
        axios
            .delete(url, { data: data })
            .then(response => {
                if (response.data.status === "success") {
                    message.success('刪除成功');
                    if (type === "department") {
                        setDepartmentProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.department_id === departmentId) {
                            setDepartmentId(null)
                        }
                    }
                    else {
                        setRoleProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.role_id === roleId) {
                            setRoleId(null)
                        }
                    }
                }
                else {
                    message.error('刪除失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {

            })
    };
    const getDepartmentId = (node) => {
        if (node) {
            setDepartmentId(node?.department_id)
            let name = node?.department_language_data[0].language_culture_value
            setDepartmentName(name !== undefined ? name : node?.name)
        }
        else {
            setDepartmentId(null)
        }
    }

    const {
        DepartmentDepthData,
        getDepartmentDepthData
    } = useDepartmentDepth({
        onBefore: () => {
            // setLoading(true)
        },
        onFinish: ({ values }) => {
            let columns = [];
            values?.forEach(departmentDepth => {
                Object.entries(departmentDepth?.property_json)?.forEach(([property_json_key, property_json_value]) => {
                    columns.push({
                        title: property_json_key,
                        key: property_json_key,
                        dataIndex: property_json_key,
                        render: (text, record) => <>
                            {/* 拿個人部門 */}
                            {record?.user_department_role_data?.map(item => <>
                                {/* 篩選層級 */}
                                {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                    {/* 篩選屬性 */}
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItem?.property_json?.[property_json_key]}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>
                    })
                })
                columns.push({
                    title: departmentDepth?.depth_name,
                    key: departmentDepth?.depth_name,
                    dataIndex: departmentDepth?.depth_name,
                    render: (text, record) => <>
                        {/* 拿個人部門 */}
                        {record?.user_department_role_data?.map(item => <>
                            {/* 篩選層級 */}
                            {item?.all_department_data?.filter(itemItem => itemItem?.depth === departmentDepth?.depth_id).map(itemItem => <>
                                {/* 篩選語言 */}
                                {itemItem?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItemItem?.language_culture_value}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>)}
                    </>
                })
                // })
                // columns.push({
                //     title: departmentDepth?.depth_name,
                //     key: departmentDepth?.depth_name,
                //     dataIndex: departmentDepth?.depth_name,
                // })
            })
            // set_default_column([
            //     ...columns,
            //     ...defaultColumns
            // ])
            // setLoading(false)
        }
    })

    const currentDepthId = departmentDepthDatas?.findIndex((item) => {
        if (
            String(item?.department_depth_id) === departmentDepthIdExternal
        ) {
            return true
        }
    })
    const preDepartmentDepthData = departmentDepthDatas?.find((item, index) => {
        if (currentDepthId === (index + 1)) {
            return true
        }
    })

    const currentDepartmentDepthData = departmentDepthDatas?.find((item) => {
        if (
            String(item?.department_depth_id) === departmentDepthIdExternal
        ) {
            return true
        }
    })

    const nextDepartmentDepthData = departmentDepthDatas?.find((item, index) => {
        if (currentDepthId === (index - 1)) {
            return true
        }
    })

    //下拉選單項目、defaultValue
    const options = preDepartmentDepthData?.department_depth_data?.map((item) => ({
        label: item?.department_language_data.find(
            (languageItem) => languageItem?.language_culture_code === "zh-tw"
        )?.language_culture_value,
        value: String(item?.classify_structure_type_id),
    }));

    const defaultOption = options?.[0]; // 預設第一個值

    useEffect(() => {
        if (userData) {
            axios.get('/organization_structure/api/user_role', {
                params: {
                    department_id: departmentId,
                    role_id: roleId
                }
            })
                .then(response => {
                    let newTargetKeys = []
                    newTargetKeys = response.data['data'].map((map_item, index) => (
                        map_item.user_id.toString()
                    ))
                    setTargetKeys(newTargetKeys)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [userData])

    useEffect(() => {
        setUserData([])
        if (roleId) {
            axios.get('/organization_structure/api/user')
                .then(response => {
                    let newUserData = []
                    newUserData = response.data?.data?.map((map_item, index) => {
                        return {
                            key: String(map_item.user_id),
                            title: `${map_item.staff_name}-${map_item.serial_name}`
                        }
                    })
                    setUserData(newUserData)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [roleId])


    const init = async () => {
        let firstDepartment
        await axios.get('/organization_structure/api/department_depth', {
            params: {
                // department_depth_id: departmentDepthIdExternal
                department_id: departmentIdExternal
            }
        })
            .then(response => {
                setDepartmentDepthDatas(response.data['data'])
                setLoading(false)
                // firstDepartment = response.data['data']?.find(_ => true)?.department_id
            })
            .catch((error) => {
            })
            .finally(() => {
            })
        // if (departmentIdExternal) {
        //     current_department_id.current = departmentIdExternal
        //     setDepartmentId(isInteger(departmentIdExternal) ? parseInt(departmentIdExternal) : departmentIdExternal)
        // } else if (firstDepartment) {
        //     current_department_id.current = firstDepartment
        //     setDepartmentId(isInteger(firstDepartment) ? parseInt(firstDepartment) : firstDepartment)
        // }
    }
    useEffect(() => {
        init()
    }, [departmentDepthIdExternal])

    useEffect(() => {
    }, [targetKeys])
    useEffect(() => {
        setForceReload(pre => pre + 1)
    }, [current_department_id.current])

    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            <Row gutter={[8, 8]} align={'top'} key={queryString}>
                <Col span={24}>
                    <Row gutter={[8, 8]} align={'top'} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                        <Col>
                            <Button
                                type="primary"
                                style={{ verticalAlign: 'middle', backgroundColor: "#E6E2C3", color: "black" }}
                                onClick={(e) => {
                                    if (currentDepthId > 1) {
                                        navigate('./../depth?' + jsonToQueryString({ department_depth_id: preDepartmentDepthData?.department_depth_id, department_id: preDepartmentDepthData?.department_id }))
                                    }
                                    else {
                                        navigate(`./../${backEditPath}`)
                                    }
                                }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {/* 返回箭頭 */}
                                    <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
                                </div>
                                返回編輯{preDepartmentDepthData?.depth_name}資料
                            </Button>
                        </Col>
                        <Col>
                            <Typography.Title level={3}>
                                {currentDepartmentDepthData?.depth_name} - 資料設定
                            </Typography.Title>
                        </Col>
                    </Row>
                </Col>
                {showDepthTabs && currentDepthId > 1 &&
                    <Col>
                        <Tabs
                            defaultActiveKey={tabDepartmentId.current}
                            items={[
                                {
                                    key: undefined,
                                    tab: '全部'
                                },
                                ...preDepartmentDepthData?.department_depth_data?.map((item) => {
                                    return {
                                        key: item?.classify_structure_type_id,
                                        tab: item.department_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title
                                    }
                                }
                                )
                            ]}
                            onChange={(ClassifyStructureTypeId) => {
                                tabDepartmentId.current = ClassifyStructureTypeId
                                setLoading(true);
                                setTimeout(() => setLoading(false), 100)
                                if (departmentId === undefined) {
                                    getDepartmentDepthData({ department_id: 0 })
                                } else {
                                    getDepartmentDepthData({ department_id: departmentId })
                                }
                            }}
                        />
                    </Col>
                }
                <Col span={24}>
                    {
                        !loading &&
                        <ClassifyStructure
                            propsPostChildren={false}
                            selectRef={selectRef}
                            propsForm={form}
                            prefixTitle="department"
                            apiRoute='/organization_structure/api/department'
                            customColumns={[
                                // 後端資料需要拿parent的Name
                                // {
                                //     title: preDepartmentDepthData?.depth_name,
                                //     dataIndex: preDepartmentDepthData?.depth_name,
                                //     key: preDepartmentDepthData?.depth_name,
                                //     render: (text, record, index) => (
                                //         console.log(record.department_language_data)
                                //     )
                                // },
                                {
                                    title: '中文名稱',
                                    dataIndex: 'name',
                                    key: 'name',
                                    render: (text, record, index) => (
                                        record[`department_language_data`]?.[0]?.language_culture_value !== undefined
                                            ? record[`department_language_data`]?.[0].language_culture_value
                                            : record.name
                                    )
                                },
                                {
                                    title: '代號',
                                    dataIndex: 'department_code',
                                    key: 'department_code'
                                },
                                ...Object.keys(currentDepartmentDepthData?.property_json ?? {})?.map((key, index) => {
                                    return {
                                        title: key,
                                        dataIndex: key,
                                        key: key,
                                        render: (text, record) => {
                                            return record?.property_json?.[key]
                                        }
                                    }
                                }),
                                ...departmentDepthDatas?.filter((item) => {
                                    if (
                                        item?.depth_id < currentDepthId && item?.depth_id != 0
                                    ) {
                                        return true
                                    }
                                })?.map((item, index) => {
                                    return {
                                        title: String(item?.depth_name),
                                        dataIndex: String(item?.depth_name),
                                        key: String(item?.depth_name),
                                        render: (text, record) => {
                                            return record?.all_department_data?.find(findItem => findItem?.depth === item?.depth_id + 1)?.[`department_language_data`]?.[0]?.language_culture_value
                                                ?? '-'
                                        }
                                    }
                                })
                            ]}
                            propsSort={false}
                            extraActionRender={(record) =>
                                <>
                                    {nextDepartmentDepthData &&
                                        <Button type="primary"
                                            style={{ verticalAlign: 'middle', backgroundColor: "#A0937D" }}
                                            onClick={(e) => {
                                                navigate('./../depth?' + jsonToQueryString({ department_depth_id: nextDepartmentDepthData?.department_depth_id, department_id: nextDepartmentDepthData?.department_id, from_department_id: record?.classify_structure_type_id }))
                                            }}
                                        >{nextDepartmentDepthData?.depth_name}資料設定</Button>
                                    }
                                </>
                            }
                            customFormItems={() => {
                                return <>
                                    <Form.Item
                                        name={"department_id"}
                                        hidden
                                    ></Form.Item>
                                    <Form.Item
                                        label={'代號'}
                                        name={"department_code"}
                                        rules={[
                                            {
                                                required: true,
                                                message: `此為必填項目`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    {
                                        preDepartmentDepthData?.length !== 0 &&
                                        <Form.Item
                                            label={preDepartmentDepthData?.depth_name}
                                            name={"classify_structure_type_id"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: `此為必填項目`,
                                                },
                                            ]}
                                        >
                                            <Select
                                                options={options}
                                                defaultValue={currentDepthId < 2 ? defaultOption : null}
                                                disabled={currentDepthId < 2}
                                            >
                                            </Select>
                                        </Form.Item>
                                    }
                                    <Form.Item
                                        name={"department_language_data.0.language_manage_id"}
                                        hidden
                                    ></Form.Item>
                                    <Form.Item
                                        name={"department_language_data.0.language_culture_code"}
                                        hidden
                                    >
                                    </Form.Item>
                                    <Form.Item
                                        name={"department_language_data.0.language_culture_value"}
                                        hidden
                                    >
                                    </Form.Item>
                                    <Form.Item
                                        name={"property_json"}
                                    >
                                        <PropertyJson actionMode={"postValue"} />
                                    </Form.Item>
                                </>
                            }}
                            toolBarRender={(tools) => {
                                return (
                                    [
                                        ...tools,
                                        <ColumnExtendButton departmentDepthId={departmentDepthIdExternal} />
                                    ]
                                )
                            }
                            }
                            classify_structure_id={null}
                            classify_structure_type_id={null}
                            initialValues={{
                                "classify_structure_type_id": tabDepartmentId.current,
                                "department_language_data": [
                                    {
                                        "language_manage_id": undefined,
                                        "language_culture_code": "zh-tw",
                                        "language_culture_value": ""
                                    }
                                ]
                            }}
                            reorganizeFormData={(value, type) => {
                                if (type === "submit") {
                                    let newData = [{
                                        "department_id": value?.department_id,
                                        "department_code": value?.department_code,
                                        "classify_structure_id": 9,
                                        "classify_structure_type_id": value.classify_structure_type_id || defaultOption.value,
                                        "name": value?.name,
                                        "department_language_data": [
                                            {
                                                "language_manage_id": value?.department_language_data?.[0]?.language_manage_id,
                                                "language_culture_code": "zh-tw",
                                                "language_culture_value": value?.name
                                            }
                                        ],
                                        "property_json": value?.property_json
                                    }]
                                    let firstData = newData.find((ele) => true)
                                    return {
                                        ...firstData
                                    };
                                } else if (type === "set") {
                                    let newData = [{
                                        "department_id": value?.department_id,
                                        "department_code": value?.department_code,
                                        "department_department_index": 1,
                                        "classify_structure_id": 9,
                                        "classify_structure_type_id": value?.classify_structure_type_parent_id,
                                        "name": value?.[`department_language_data`]?.[0]?.language_culture_value !== undefined
                                            ? value[`department_language_data`]?.[0].language_culture_value
                                            : value?.name,
                                        "department_language_data": [
                                            {
                                                "language_manage_id": value?.department_language_data?.[0]?.language_manage_id,
                                                "language_culture_code": "zh-tw",
                                                "language_culture_value": value?.name
                                            }
                                        ],
                                        "property_json": value?.property_json
                                    }]
                                    let firstData = newData.find((ele) => true)
                                    return {
                                        ...firstData
                                    };
                                }
                            }}
                            extraParams={{
                                department_depth_id: departmentDepthIdExternal,
                                classify_structure_type_id: tabDepartmentId.current
                            }}
                            chartShow={false}
                            treeData={departmentData}
                            onSubmit={addModal}
                            onChange={editModal}
                            processData={departmentProcessData}
                            deleteNode={deleteDepartment}
                            onSelect={getDepartmentId}
                            chartTitle={'單位組織架構圖'}
                            treeTitle={''}
                            extra_column={[
                                {
                                    title: '職位數',
                                    dataIndex: 'count_role',
                                    key: 'count_role'
                                },
                                {
                                    title: '人員數',
                                    dataIndex: 'count_user',
                                    key: 'count_user'
                                },
                            ]}
                            link={(record) => {
                            }}
                            showMode={"page"}
                            propsShowSetting={<>
                                <Row gutter={[0, 16]}>
                                    <Col>層級頁籤：<Switch
                                        value={showDepthTabs}
                                        name={''}
                                        checkedChildren={'開'}
                                        unCheckedChildren={'關'}
                                        onChange={e => setShowDepthTabs(e.target.value)}
                                    /></Col>
                                </Row>
                            </>}
                            propsCancel={false}
                        />
                    }
                </Col>
            </Row>
        </LanguageContext.Provider>
    </>)
}
export default DepthDataManagement;

const PropertyJson = ({
    value,
    onChange,
    actionMode = "postColumn",
    ...props
}) => {
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (values) => {
        //做一些你可能會用到其他component的資料整理
        const result = values?.property_json?.reduce((acc, curr) => {
            acc[curr.type] = curr.name;
            return acc;
        }, {});
        onChange({
            target: {
                name: props?.name,
                value: {
                    ...result,
                }
            }
        })
        props?.onValueChange({
            target: {
                name: props?.name,
                value: {
                    ...result,
                }
            }
        })
    };
    useEffect(() => {
        form.setFieldsValue({
            property_json: Object.entries(value).map(([type, name]) => (
                {
                    type,
                    name
                }
            ))
        })
    }, [value])
    return <>
        <Form
            form={form}
            onValuesChange={(values) => {
                setFormValuesOtherThings(values)
            }}
        >
            <Form.List
                name={"property_json"}
            >
                {(fields, { add, remove }) => <>
                    {actionMode === "postColumn" ?
                        <Button onClick={() => {
                            add()
                        }}>新增欄位</Button>
                        : <></>}
                    {fields.map((field, index) => <>
                        {actionMode === "postColumn" ?
                            <Row gutter={[16, 16]}>
                                <Col>
                                    <Form.Item
                                        label={'欄位名稱'}
                                        name={[field.name, "type"]}
                                        rules={[
                                            {
                                                required: true,
                                                message: `此為必填項目`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item
                                        label={'欄位預設值'}
                                        name={[field.name, "name"]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Button
                                        type={'danger'}
                                        onClick={() => {
                                            remove(index)
                                            const values = form.getFieldsValue();
                                            setFormValuesOtherThings(values)
                                        }}
                                    >刪除欄位</Button>
                                </Col>
                            </Row>
                            :
                            <>
                                <Form.Item
                                    hidden
                                    label={'欄位名稱'}
                                    name={[field.name, "type"]}
                                    rules={[
                                        {
                                            required: true,
                                            message: `此為必填項目`,
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label={form.getFieldValue([field.name, "type"])}
                                    name={[field.name, "name"]}
                                >
                                    <Input />
                                </Form.Item>
                            </>}
                    </>)}
                </>}
            </Form.List>
        </Form>
    </>
}
export { PropertyJson }

const ColumnExtendButton = ({
    departmentDepthId,
    keyPrefix
}) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onFormFinish = (value) => {
        let { department_depth_data, ...formValues } = form.getFieldsValue()
        patchDepartmentDepthData([formValues]);
    }
    const {
        DepartmentDepthData,
        getDepartmentDepthData,
        patchDepartmentDepthData
    } = useDepartmentDepth({
        onBefore: () => { },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "get") {
                    form.setFieldsValue({ ...values?.find(_ => true) })
                } else if (axiosMode === "post") {
                    message.success("新增成功");
                } else if (axiosMode === "patch") {
                    message.success("修改成功");
                } else if (axiosMode === "delete") {
                    message.success("刪除成功");
                }
                if (axiosMode !== "get") {
                    setOpen(false);
                }
            } else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗");
                } else if (axiosMode === "patch") {
                    message.error("修改失敗");
                } else if (axiosMode === "delete") {
                    message.error("刪除失敗");
                }
                setOpen(false);
            }
        }
    })

    useEffect(() => {
        getDepartmentDepthData({ department_depth_id: departmentDepthId })
        form.setFieldsValue({ department_depth_id: departmentDepthId })
    }, [departmentDepthId])
    return (
        <>
            <Button
                type="primary"
                style={{
                    color: "#000",
                    backgroundColor: "#C5D3E8",
                }}
                onClick={(e) => { setOpen(true) }}
            >
                欄位擴充設定
            </Button>
            <MainModal
                axiosMode="patch"
                propsForm={form}
                propsOpen={open}
                propsSetOpen={setOpen}
                onFinish={onFormFinish}
                width={1000}
                formElement={<ColumnExtendForm></ColumnExtendForm>}
                keyPrefix={keyPrefix}
            />
        </>
    )
}

const ColumnExtendForm = ({
    propsForm = null,
    propsValue = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    customFormItems = () => { },
    defaultValue = {},
    propsOnValuesChange = () => { },
    fieldName
}) => {
    const [form] = Form.useForm();
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };

    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        propsOnValuesChange(formValues)
        //   setFormValuesOtherThings(formValues);
    };

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);
    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        name={"department_depth_id"}
                        hidden
                    >
                    </Form.Item>
                    <Form.Item
                        name={"single"}
                        hidden
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={"property_json"}
                    >
                        <PropertyJson />
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
}
